import { ReactElement } from "react";
import { StyledDialog } from "src/components/modal/senec-dialog/SenecDialog.styled";
import { SenecIconDialogContent } from "src/components/modal/senec-icon-dialog/SenecIconDialogContent";

export interface SenecIconDialogProps {
    /**
     * id to find component in render tests
     */
    "data-testid"?: string;

    /**
     * header title
     */
    title: string;

    /**
     * show dialog
     */
    isOpen: boolean;

    /**
     * a callback function that gets called when the component is closed.
     */
    onClose: () => void;

    /**
     * a ReactElement which is displayed in the center
     */
    MainComponent?: ReactElement;

    /**
     * a ReactElement which is displayed at the bottom
     */
    BottomComponent?: ReactElement;

    /**
     * an icon to be displayed in the dialog header
     */
    icon?: ReactElement;

    /**
     * show close button
     */
    showCloseButton?: boolean;

    /**
     * header size
     */
    headerSize?: "small" | "medium";

    /**
     * dialog width in px
     */
    width?: number;
}

// @deprecated use `SenecDialog` instead
export const SenecIconDialog = ({
    title,
    isOpen,
    onClose,
    MainComponent,
    BottomComponent,
    icon,
    "data-testid": dataTestId = "senec-icon-dialog",
    showCloseButton = true,
    headerSize = "medium",
    width,
}: SenecIconDialogProps) => {
    const onDialogClose = (event?: object, reason?: string) => {
        if (reason !== "backdropClick") {
            onClose();
        }
    };

    return (
        <StyledDialog open={isOpen} onClose={onDialogClose} maxWidth={false}>
            <SenecIconDialogContent
                data-testid={dataTestId}
                title={title}
                MainComponent={MainComponent}
                BottomComponent={BottomComponent}
                icon={icon}
                showCloseButton={showCloseButton}
                headerSize={headerSize}
                width={width}
                onClose={onClose}
            />
        </StyledDialog>
    );
};
